import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import './App.css';
import './Hospedaje';

import App from './App';
import Hospedaje from './Hospedaje';

import reportWebVitals from './reportWebVitals';




var url_string = window.location.href
var url = new URL(url_string);
var i = url.searchParams.get("i");

const root = ReactDOM.createRoot(document.getElementById('root'));

if( i  != undefined){
  root.render(
    <React.StrictMode> 
      <Hospedaje/>
    </React.StrictMode>
  );
}else{
  root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
